export class Grade {
    #fontGrade: string;
    #index: number

    constructor(fontGrade: string) {
        fontGrade = fontGrade.trim();
        if (fontGrade.length == 0) {
            throw new Error('Font grade is too short');
        }
        const firstNonDigitIndex = fontGrade.search(/\D/);
        if (firstNonDigitIndex == 0) {
            throw new Error('Font grade must begin with a number');
        }
        const number = parseInt(fontGrade.substring(0, firstNonDigitIndex));
        if (number < 6) {
            throw new Error('Grade number too low');
        }
        let letterNumber = 0;
        if (firstNonDigitIndex < fontGrade.length) {
            const letters = ['A', 'B', 'C'];
            const letter = fontGrade[firstNonDigitIndex];
            if (!letters.includes(letter)) {
                throw new Error('Invalid letter');
            }
            letterNumber = letters.lastIndexOf(letter) + 1;
        }
        const signIndex = firstNonDigitIndex + 1;
        let signNumber = 0;
        if (signIndex < fontGrade.length) {
            if (fontGrade[signIndex] == '+') {
                signNumber = 1;
            }
            else {
                throw new Error('Invalid sign');
            }
        }
        /* Nothing is easier than 6A */
        this.#index = (number - 6) * 6 + letterNumber * 2 + signNumber;
        this.#fontGrade = fontGrade;
    }

    get text() {
        return this.#fontGrade;
    }

    get index() {
        return this.#index;
    }
}